import { Injectable, Signal, inject } from '@angular/core';
import { Router, isActive } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class RouterService {
	private router = inject(Router);

	isMyRecord: Signal<boolean> = isActive('/tacit/my-record', this.router, {
		paths: 'subset',
		queryParams: 'subset',
		fragment: 'ignored',
		matrixParams: 'ignored',
	});
}
